import type { FlowState, FlowNode, Viewport } from "../types";

export interface DefaultNodeState {
    nodes: FlowNode[];
    edges: [];
    viewport: Viewport;
}

export const defaultNodeState: DefaultNodeState = {
    nodes: [
        {
            id: "starting-node",
            type: "startingNode",
            position: {
                x: 220,
                y: 100
            },
            data: {
                startingText: "Invite Link",
                isBottom: true,
                type: "startingNode"
            } as any,
            width: 280,
            height: 60
        }
    ],
    edges: [],
    viewport: {
        x: 0,
        y: 0,
        zoom: 1
    }
};

export const defaultNodeScreeningState: DefaultNodeState = {
    nodes: [
        {
            id: "starting-node",
            type: "startingNode",
            position: {
                x: 220,
                y: 100
            },
            data: {
                startingText: "Invite Link",
                isBottom: true,
                type: "startingNode"
            } as any,
            width: 280,
            height: 60
        },
        {
            id: "starting-node-2",
            type: "startingNode",
            position: {
                x: 820,
                y: 100
            },
            data: {
                startingText: "Apply Link",
                isBottom: true,
                type: "startingNode"
            } as any,
            width: 280,
            height: 60
        }
    ],
    edges: [],
    viewport: {
        x: 0,
        y: 0,
        zoom: 1
    }
};

export const FLOW_TYPE = {
    TEMPLATE: "Template",
    PROFILE: "Profile"
} as const;

export type FlowTypeKey = keyof typeof FLOW_TYPE;
export type FlowTypeValue = typeof FLOW_TYPE[FlowTypeKey];

export const FLOW_TYPE_SCREENING = 36 as const;
export const FLOW_TYPE_RECONNECT = 37 as const;
export const FLOW_TYPE_COMPLIANCE = 89 as const;
export const FLOW_TYPE_FAQ = 83 as const;

export type ProfileType = 
    | typeof FLOW_TYPE_SCREENING 
    | typeof FLOW_TYPE_RECONNECT 
    | typeof FLOW_TYPE_COMPLIANCE 
    | typeof FLOW_TYPE_FAQ;
